const FEATURED_LINKS = {
    SHOP_MY_STORE_SID: 'FeaturedLink_ShopYourStore',
    SHOP_SAME_DAY_SID: 'FeaturedLink_ShopSameDay'
};

const COMPONENT_SIDS = {
    SHOP_MY_STORE_BUY_IT_AGAIN: 'shop-happening_productlist_buyitagain',
    SHOP_MY_STORE_FROM_YOUR_LOVES: 'shop-store-happening_productlist_fromyourloves',
    SHOP_MY_STORE_SERVICES: 'shop-store-happening-services-carousel',
    SHOP_MY_STORE_EVENTS: 'shop-store-happening-events-carousel',
    SHOP_SAME_DAY_BUY_IT_AGAIN: 'sameday-happening_productlist_buyitagain',
    SHOP_SAME_DAY_FROM_YOUR_LOVES: 'sameday-happening_productlist_fromyourloves'
};

const NEW_BADGE = {
    EN: 'New',
    FR: 'Nouv'
};

const LANDING_PAGE = {
    TIMEOUT: 3000,
    ZIP_CODE_DETAILS: 'sameDay',
    STORE_DETAILS: 'storeDetails'
};

const ELEMENTS_IDS = {
    SHOP_MY_STORE: 'shopMyStore',
    SHOP_SAME_DAY: 'shopSameDay',
    STORE_DETAILS: 'storeDetails',
    FIND_SEPHORA: 'findASephora',
    SERVICES_EVENTS: 'servicesAndEvents'
};

export {
    FEATURED_LINKS, COMPONENT_SIDS, NEW_BADGE, LANDING_PAGE, ELEMENTS_IDS
};
